import { useContext, useState } from 'react';
import RegisterSection from './RegisterSection';
import { AllMenuItems, Certification, Faq, Mentors, Rewards } from './MenuItems/MenuItems';
import { EventContext } from 'pages/events';

const ContentSection = () => {
  const { overview, instructor, rewardImage, faq, rewardText, certification } =
    useContext(EventContext);
  const menuItems = [
    overview && 'overview',
    instructor && 'instructor',
    rewardText && rewardImage?.data && 'prizes',
    certification?.data && 'certification',
    faq?.length && 'FAQs',
  ];
  const [selectedMenu, setSelectedMenu] = useState(menuItems[0]);

  const handleMenuChange = (menu) => (e) => {
    if (selectedMenu === menu) return;
    setSelectedMenu(menu);
  };

  return (
    <>
      <section className="sticky top-14 z-30 mt-10 flex items-center border-b-2 border-solid border-gray-6 bg-white px-3 pt-6 text-center capitalize md:px-16">
        <div className="scrollbar-hidden -mb-0.5 flex items-center overflow-x-auto text-base">
          {menuItems?.filter(Boolean)?.map((menu) => (
            <div
              key={menu}
              name={menu}
              onClick={handleMenuChange(menu)}
              className={`cursor-pointer  ${
                selectedMenu === menu ? 'border-red  text-red' : ' border-transparent  text-gray-1'
              } mr-3 w-auto whitespace-nowrap border-b-4  border-solid py-2 px-1 font-satoshi-medium font-medium  md:mr-8 md:p-2`}
            >
              {menu}
            </div>
          ))}
        </div>
      </section>
      <section className="mx-auto mb-44 mt-10 grid  items-start md:mb-0 md:w-11/12 md:grid-cols-6 lg:grid-cols-6">
        <section className="mx-2 md:col-span-4 md:mx-0 md:w-11/12 lg:col-span-4">
          {(() => {
            switch (selectedMenu) {
              case 'instructor':
                return <Mentors />;
              case 'prizes':
                return <Rewards />;
              case 'certification':
                return <Certification />;
              case 'FAQs':
                return <Faq />;
              default:
                return <AllMenuItems />;
            }
          })()}
        </section>
        <section className="fixed right-0 left-0 bottom-0 z-30 md:sticky md:top-36 md:z-20 md:col-span-2 lg:col-span-2">
          <RegisterSection />
        </section>
      </section>
    </>
  );
};

export default ContentSection;
